export { default as CoreIcon } from './icon';
export type { CoreIconProps } from '../shared/types/icon.types';
